import { request } from "../axios/request";
import { getLocalItem, objectSelector } from "theme/utils";

import {
  FETCH_STOCK_LOCATION_PENDING,
  FETCH_STOCK_LOCATION_REJECTED,
  FETCH_STOCK_LOCATION_FULFILLED,
  FETCH_ALL_STOCK_LOCATIONS_FULFILLED,
  FETCH_ALL_STOCK_LOCATIONS_REJECTED,
} from "../constants/stockLocation";

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_STOCK_LOCATION_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_STOCK_LOCATION_FULFILLED,
  response,
});

const rejected = (error) => ({
  type: FETCH_STOCK_LOCATION_REJECTED,
  error,
});

const locationsFulfilled = (response) => ({
  type: FETCH_ALL_STOCK_LOCATIONS_FULFILLED,
  response,
});

const locationsRejected = (error) => ({
  type: FETCH_ALL_STOCK_LOCATIONS_REJECTED,
  error,
});

export const fetchStockLocation = () => (dispatch, getState) => {
  dispatch(pending());

  const {
    staffs: { currentStaff },
  } = getState();
  const remoteId = objectSelector(currentStaff, "current_store.remote_id");
  const usedStorage = JSON.parse(getLocalItem("usedStorage"));
  const localRemoteId = objectSelector(usedStorage, "remote_id", null);

  const params = {
    erp_code: remoteId || localRemoteId,
  };

  request({ method: "get", url: OMS.OMS.STOCK_LOCATIONS, params })
    .then((response) => dispatch(fulfilled(response.data)))
    .catch((error) => dispatch(rejected(error)));
};

export const fetchAllStockLocations = () => (dispatch) => {
  dispatch(pending());

  request({
    method: "get",
    url: `${OMS.OMS.STOCK_LOCATIONS}/?is_active=true&is_fulfillment_center=true`,
  })
    .then((response) => {
      dispatch(locationsFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(locationsRejected(error));
    });
};

export const fetchAllStockLocationsForMultipleSKUs =
  (SKUs, erpCode) => (dispatch) => {
    dispatch(pending());
    const url = `${OMS.OMS.STOCK_LOCATIONS_FOR_MULTIPLE_SKU}/?limit=9999&erp_code=${erpCode}${SKUs}`;

    request({
      method: "get",
      url,
    })
      .then((response) => {
        dispatch(locationsFulfilled(response.data));
      })
      .catch((error) => {
        dispatch(locationsRejected(error));
      });
  };



// WEBPACK FOOTER //
// ./src/actions/stockLocation.js